import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ConsultUpvoteStatus from "@/components/ConsultUpvoteStatus.vue";
export default {
  name: "MemberMyConsultation",
  components: {
    ConsultUpvoteStatus: ConsultUpvoteStatus
  },
  data: function data() {
    return {
      current: "0",
      list: [],
      limit: 10,
      page: 1,
      total: 0,
      isData: 1,
      myConsultTotal: [0, 0, 0]
    };
  },
  computed: {
    commonSetting: function commonSetting() {
      return this.$store.state.commonSetting;
    },
    types: function types() {
      var types = [{
        type: "0",
        label: "全部"
      }, {
        type: "2",
        label: "已回复"
      }, {
        type: "1",
        label: "待回复"
      }];
      return types;
    }
  },
  watch: {
    current: function () {
      var _current = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.page = 1;
                _context.next = 3;
                return this.getData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function current() {
        return _current.apply(this, arguments);
      }

      return current;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getData();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    //点赞
    handleZan: function () {
      var _handleZan = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(item) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$http.get("/api/app/teacher/consult/upvoteStatus", {
                  id: item.id
                });

              case 2:
                this.$message({
                  message: item.is_upvote == 0 ? "点赞成功！" : "取消点赞成功！",
                  type: "success"
                });
                _context3.next = 5;
                return this.getData();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleZan(_x) {
        return _handleZan.apply(this, arguments);
      }

      return handleZan;
    }(),
    delConsult: function () {
      var _delConsult = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(item) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
                  type: "warning"
                });

              case 2:
                _context4.next = 4;
                return this.$http.delete("/api/app/teacher/consult/userDelete/" + item.id);

              case 4:
                this.page = 1;
                _context4.next = 7;
                return this.getData();

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function delConsult(_x2) {
        return _delConsult.apply(this, arguments);
      }

      return delConsult;
    }(),
    getData: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var myConsultTotal, data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$http.get("/api/app/user/myConsultTotal");

              case 2:
                myConsultTotal = _context5.sent;
                this.myConsultTotal = [myConsultTotal.all_recover_num, myConsultTotal.recover_num, myConsultTotal.not_recover_num];
                _context5.next = 6;
                return this.$http.get("/api/app/user/myConsult", {
                  is_recover: this.current,
                  limit: this.limit,
                  page: this.page
                });

              case 6:
                data = _context5.sent;
                data.data.forEach(function (item) {
                  if (item.recover_info && item.recover_info.image) {
                    item.recover_info.image = item.recover_info.image.split(",");
                  }
                });
                this.list = data.data;

                if (data.data && data.data.length > 0) {
                  this.isData = 1;
                } else {
                  this.isData = 0;
                }

                this.total = data.total;

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    handlePageChange: function () {
      var _handlePageChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(page) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.page = page;
                _context6.next = 3;
                return this.getData();

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function handlePageChange(_x3) {
        return _handlePageChange.apply(this, arguments);
      }

      return handlePageChange;
    }()
  }
};